import { fetchData, apiURL } from "./api_helper";

//  USER CRUD
//  AUTH
const userLogin = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/login`;
    fetchData(endpointURL, "post", data, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

//  CREATE
const createUser = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/user`;
    fetchData(endpointURL, "post", data)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

//  READ
const readUser = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/user/${data.id}`;
    fetchData(endpointURL, "get")
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

const readUsers = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/user`;
    fetchData(endpointURL, "get", data)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

//  UPDATE
const updateUser = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/user/${data.id}`;
    fetchData(endpointURL, "PATCH", data.body)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

//  DELETE
const deleteUser = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/user/${data.id}`;
    fetchData(endpointURL, "delete")
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

export default {
  userLogin,
  createUser,
  readUser,
  readUsers,
  updateUser,
  deleteUser
};
